export const OWNER_TYPES = {
  FROM_CONTEXT_RECORD: 'assign_from_context_record',
  NEWLY_ASSIGNED: 'newly_assigned_owner',
  FROM_VARIABLE: 'assign_from_variable',
} as const;

export const OWNER_SUBTYPES = {
  ROUND_ROBIN_ANY_ROLE: 'round_robin_any_role',
  ROUND_ROBIN_SPECIFIC_ROLE: 'round_robin_specific_role',
  ROUND_ROBIN_CHOOSE_TEAM_MEMBERS: 'round_robin_choose_team_members',
  SPECIFIC_TEAM_MEMBER: 'specific_team_member',
  FROM_VARIABLE: 'assign_from_variable',
} as const;

export const EMPTY_ARRAY = [];

export const ARCHIVED_RECORD_FOUND_ACTIONS = {
  unarchive: 'unarchive',
  overwrite: 'overwrite',
  create_append_suffix: 'create_append_suffix',
  error_do_not_create: 'error_do_not_create',
} as const;

export const EXISTING_RECORD_FOUND_ACTIONS = {
  create_append_suffix: 'create_append_suffix',
  error_do_not_create: 'error_do_not_create',
} as const;

export const CONFLICT_RESOLUTIONS = {
  overwrite: 'overwrite',
  update_if_blank: 'update_if_blank',
  add_only: 'add_only',
} as const;

export const SCROLL_OPTIONS = {
  behavior: 'smooth',
  block: 'nearest',
};

export const SCROLLSTART_OPTIONS = {
  behavior: 'smooth',
  block: 'start',
};
